module.exports = __webpack_public_path__ + "assets/RetinaNarr-BookItalic.1b10595985ebfdb43431de93b76e7164.woff";